import { Component, Prop, Vue } from 'vue-property-decorator';
import lodash from 'lodash';
import { DisplayStatus } from '@/models';

@Component
export default class Status extends Vue {
  @Prop({
    default: () => {
      return {
        color: 'red',
        label: 'No status'
      };
    }
  })
  readonly status: DisplayStatus;

  get displayLabel(): string {
    return lodash.replace(this.status.label, '_', ' ');
  }
}
